/**
 * src/scripts/pages/dyad-registration/consent.js
 *
 * Informed-consent signing page (/dyad-registration/consent?token=...).
 * Bundled with every dyad-registration page, so it no-ops unless the signing
 * form is present. Posts JSON to the same path; the token in the form's
 * data attribute is the authorization (no CSRF, see routes/dyadRegistration.js).
 */

document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('dr-consent-form');
    if (!form) return;

    const agree = document.getElementById('dr-consent-agree');
    const nameInput = document.getElementById('dr-consent-name');
    const submitBtn = document.getElementById('dr-consent-submit');
    const errorBox = document.getElementById('dr-consent-error');
    const successBox = document.getElementById('dr-consent-success');

    function showError(message, focusEl) {
        errorBox.textContent = message;
        errorBox.classList.remove('is-hidden');
        if (focusEl) focusEl.focus();
    }

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        errorBox.classList.add('is-hidden');

        if (!agree.checked) {
            showError('Check the box to confirm you agree before signing.', agree);
            return;
        }
        const typedName = nameInput.value.trim();
        if (typedName.length < 2) {
            showError('Type your full name to sign.', nameInput);
            return;
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Signing…';

        try {
            const response = await fetch('/dyad-registration/consent', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({
                    token: form.dataset.token,
                    documentSha256: form.dataset.documentSha,
                    typedName,
                    agree: true,
                }),
            });
            const data = await response.json().catch(() => ({}));
            if (!response.ok || !data.success) {
                throw new Error(data.message || 'The consent could not be signed. Please try again.');
            }
            form.classList.add('is-hidden');
            successBox.classList.remove('is-hidden');
            successBox.focus();
        } catch (err) {
            showError(err.message || 'The consent could not be signed. Please try again.');
            submitBtn.disabled = false;
            submitBtn.textContent = 'Sign consent';
        }
    });
});
